import React, { useContext, useCallback, useMemo, useState } from 'react';
import { Chevron } from '@jutro/components';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { TranslatorContext,IntlContext } from '@jutro/locale';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import CoveragesComponent from '../../../../Components/CoveragesComponent/CoveragesComponent';
import ScheduleItemsDisplayComponent from '../../../../Components/ScheduleItemsDisplayComponent/ScheduleItemsDisplayComponent';
import metadata from './PolicyFarmInfoComponent.metadata.json5';
import styles from '../../Summary.module.scss';
import messages from './PolicyFarmInfoComponent.messages';
import PolicyCoverageComponent from '../PolicyCoverageComponent/PolicyCoverageComponent';
import DiscountComponent from '../../../../Components/DiscountSurchargesDisplayComponent/DiscountSurchargesDisplayComponent';


const getHeaderSection = (title, title1) => {
    return (isOpen) => (
        <React.Fragment>
            <Chevron isOpen={isOpen} align="right" className={styles.chevronStyle} />
            <h2 className={`${styles.title} ${styles.gwOverrideDefaultMargin}`}>{title}</h2>
            <h3 className={`${styles.title1} ${styles.gwOverrideDefaultMargin}`}>{title1}</h3>
        </React.Fragment>
    );
};

const getFarmOutBuildingHeaderSection = (title) => {
    return (isOpen) => (
        <React.Fragment>
            <Chevron isOpen={isOpen} align="right" className={styles.chevronStyle} />
            <h2 className={`${styles.title} ${styles.gwOverrideDefaultMargin}`}>{title}</h2>
           
        </React.Fragment>
    );
};





function PolicyFarmInfoComponent(props) {
    const translator = useContext(TranslatorContext);
    const [foCoverageOpenItems, SetFoCoverageOpenItems] = useState([]);
    const [farmCoverageOpenItems, SetFarmCoverageOpenItems] = useState([]);
    const intl = useContext(IntlContext);

    const getScheduleTypeKeyValue = (typeCode, typelistValues) => {
        const item = typelistValues.find((typeListItem) => {
            return typeListItem.code === typeCode;
        });
        return item ? item.displayKey : '';
    };

    const toggleShowHide = useCallback(
        (item) => {
            const openedItem = _.clone(foCoverageOpenItems);
            const index = _.indexOf(openedItem, item);
            if (index === -1) {
                openedItem.push(item);
                SetFoCoverageOpenItems(openedItem);
            } else {
                SetFoCoverageOpenItems(_.slice(openedItem, index, 0));
            }
        },
        [foCoverageOpenItems]
    );

    const toggleShowHideFarmCoverage = useCallback(
        (item) => {
            const openedItem = _.clone(farmCoverageOpenItems);
            const index = _.indexOf(openedItem, item);
            if (index === -1) {
                openedItem.push(item);
                SetFarmCoverageOpenItems(openedItem);
            } else {
                SetFarmCoverageOpenItems(_.slice(openedItem, index, 0));
            }
        },
        [farmCoverageOpenItems]
    );
    const getScheduleItemValue = (propertyInfo, scheduleItem, typelistValues) => {
        let value = '';
        switch (propertyInfo.valueType) {
            case 'DATE': 
                value = scheduleItem.itemData[propertyInfo.id].dateValue ? intl.formatDate(new Date(scheduleItem.itemData[propertyInfo.id].dateValue), { year: 'numeric', month: 'short', day: 'numeric' }) : '-';
                break;
            case 'INTEGER':
                value = scheduleItem.itemData[propertyInfo.id].integerValue;
                break;
            case 'STRING':
                value = scheduleItem.itemData[propertyInfo.id].stringValue;
                break;
            case 'BOOLEAN':
                if(scheduleItem.itemData[propertyInfo.id])  {
                    value = `${translator( 
                        scheduleItem.itemData[propertyInfo.id].booleanValue ? messages.infoYes : messages.infoNo
                    )}`;
                }else {
                    value = ''
                }
                break;
            case 'TYPEKEY':
                value = getScheduleTypeKeyValue(scheduleItem.itemData[propertyInfo.id].typeCodeValue, typelistValues);
                break;

            default:
                break;
        }
        return value;

    };

    const getAvailableTypelistForSscheduledItems = (columnNameTypeList, propertyInfos) => {
        propertyInfos.forEach((propertyInfo) => {
            columnNameTypeList = propertyInfo.valueType === 'TYPEKEY' ? columnNameTypeList.concat(propertyInfo.availableTypeListValues) : columnNameTypeList;
        });
        return columnNameTypeList;
    };

    const getscheduleLineItem = (propertyInfos, scheduleItem, availableTypeList) => {
        const scheduleLineItem = {};
        propertyInfos.forEach((propertyInfo) => {
            const colName = propertyInfo.label;
            scheduleLineItem[colName] = getScheduleItemValue(propertyInfo, scheduleItem, availableTypeList);
        });
        return scheduleLineItem;
    };

    const getAdditionalCoveragesData = (additionalCoverages) => {
        return additionalCoverages.filter((addlCoverage) => {
            return addlCoverage.selected;
        });
    };

    const getLocationOutBuildings = (outBuildings) => {
        return outBuildings.filter((obj) => {
            return obj.additionalCoverages[0].selected;
        })
            .map((outBuilding) => {
                return {
                    name: outBuilding.outBuildingName,
                    deductible: outBuilding.additionalCoverages[0].terms.length >1 ? outBuilding.additionalCoverages[0].terms[1].chosenTermValue : 0,
                    limit: outBuilding.additionalCoverages[0].terms.length >0 ? outBuilding.additionalCoverages[0].terms[0].chosenTermValue: 0,
                    premium: outBuilding.additionalCoverages[0].amount ? outBuilding.additionalCoverages[0].amount: 0
                };
            });
    };

    const getFarmLOBData = () => {
        const farmLOBData = _.cloneDeep(props.value);
        farmLOBData.locations?.forEach((location) => {
            let availableTypeList = [];
            const filteredSchedules = _.filter(
                location.schedules, (schedule) => {
                    return schedule.scheduleItems.length > 0;
                }
            );
            filteredSchedules.forEach((fschedule) => {
                const scheduleLineItems = [];
                availableTypeList = getAvailableTypelistForSscheduledItems(availableTypeList, fschedule.propertyInfos);
                fschedule.scheduleItems.forEach((scheduleItem) => {
                    const scheduleLineItem = getscheduleLineItem(fschedule.propertyInfos, scheduleItem, availableTypeList);
                    scheduleLineItems.push(scheduleLineItem);
                });
                fschedule.scheduleLineItems = scheduleLineItems;
            });
            location.filteredSchedules = filteredSchedules;
            location.addlCoverages = getAdditionalCoveragesData(location.additionalCoverages);
            location.outBuildingCoverages = getLocationOutBuildings(location.farmOutbuildings);
        });
        return farmLOBData;
    };

    const farmLOBData = getFarmLOBData();

    if (_.isEmpty(farmLOBData)) {
        return null;
    }

    const readValue = useCallback(
        (id, path) => {
            if (path === 'locations') {
                return farmLOBData.locations;
            }
            return _.get(farmLOBData, path);
        },
        [farmLOBData]
    );
    function getCell(items, index, property) {
        if('name' === property.id) {
            return items.policyAdditionalInterest.displayName;
        }
        return items[property.id];
    };

    const checkEmpty = (location) => {
        return _.isEmpty(location.filteredSchedules)
            && _.isEmpty(location.addlCoverages)
            && _.isEmpty(location.filteredSchedules);
    };

    const generateScheduleDataOverrides = useCallback((filteredSchedules) => {
        const overrides = filteredSchedules.map((filteredSchedule, index) => {
            return {
                [`ScheduleItemsHeader${index}`]: {
                    content: filteredSchedule.displayName
                },
               
            };
        });
        return Object.assign({}, ...overrides);
    }, []);

   const generateFarmOutBuildingDataOverride = useCallback((farmOutbuildings) => {

    const overrides = farmOutbuildings.map( (farmOutbuilding, index) => {
        return {
            [`FarmOutBuildingCoverageDetailsHeader${index}`]: {
                content :farmOutbuilding.outBuildingName
            },
            [`foShowContentToggleLink${index}`]: {
                onClick: () => toggleShowHide(index)
            },
            [`foContentDetailToggle${index}`]: {
                icon: _.includes(foCoverageOpenItems, index) ? 'caret-up' : 'caret-down',
                message: _.includes(foCoverageOpenItems, index)
                    ? translator(messages.hideOutBuildingCoverages)
                    : translator(messages.showOutBuildingCoverages)
            },
            [`foCoverageContainer${index}`]: {
                visible: _.includes(foCoverageOpenItems, index),
                show: foCoverageOpenItems
            },
            [`fobPackageDetailsContainer${index}`]: {
                header: getFarmOutBuildingHeaderSection(farmOutbuilding.outBuildingName)
            },
            [`farmBuildingAccordionEmptyMsg${index}`] :{
                visible : farmOutbuilding.additionalCoverages === undefined

            }

        }
       
    });
    return Object.assign({}, ...overrides);
   }, [foCoverageOpenItems]);

   const getDiscountsAndSurcharges = (discounts, surcharges) => {
        let discountSurcharges = [];
        discountSurcharges = discounts && !_.isEmpty(discounts) ? discounts : [];
        discountSurcharges = surcharges && !_.isEmpty(surcharges) ? discountSurcharges.concat(surcharges) : discountSurcharges;
        return _.sortBy(discountSurcharges, 'category');
    };


    const generateAccordionHeaderOverrides = useCallback(() => {
        const farmLOBLocations = farmLOBData.locations || [];
        const overrides = farmLOBLocations.map((location, index) => {
            const count = index + 1;
            //TODO: Update the premium while complete the FRAM rate book 
            const headName = `Farm Package # ${count} : ${location.farmPackageDetails.farmProgramType}`;
            const title = 'Location : '+ location.displayName;
            const ftfdVisible = ['1'];
            const ssVisible = ['1','2'];
            const fireProtectionGrade = location.farmPackageDetails.fireProtectionGrade_EY;

            const discountsAndSurcharges = getDiscountsAndSurcharges(location.discounts, location.surcharges);

            return {
                [`farmPackageDetailsContainer${index}`]: {
                    header: getHeaderSection(title,headName)
                },
                [`FarmOutBuildingCoverageContainer${index}`]: {
                    visible: !_.isEmpty(location.farmOutbuildings) && !_.isEmpty(location.farmOutbuildings[0].additionalCoverages)
                },
                [`AdditionalCoverageContainer${index}`]: {
                    visible: !_.isEmpty(location.addlCoverages)
                },
                [`ScheduleItemsCoverageContainer${index}`]: {
                    visible: !_.isEmpty(location.filteredSchedules)
                },
                [`accordionEmptyMsg${index}`]: {
                    visible: checkEmpty(location)
                },
                [`hasFullTimeFireDepartmentColumn${index}`]: { 
                    visible : ftfdVisible.includes(fireProtectionGrade)
                },  
                [`hasSuperiorShuttleColumn${index}`]: { 
                    visible : ssVisible.includes(fireProtectionGrade)
                }, 
                [`farmShowContentToggleLink${index}`]: {
                    onClick: () => toggleShowHideFarmCoverage(index)
                },
                [`farmContentDetailToggle${index}`]: {
                    icon: _.includes(farmCoverageOpenItems, index) ? 'caret-up' : 'caret-down',
                    message: _.includes(farmCoverageOpenItems, index)
                        ? translator(messages.hideFarmCoverages)
                        : translator(messages.showFarmCoverages)
                },
                [`farmCoverageContainer${index}`]: {
                    visible: _.includes(farmCoverageOpenItems, index),
                    show: farmCoverageOpenItems
                },
                [`policyFarmDiscounts${index}`]:{
                    data: discountsAndSurcharges,
                    value: discountsAndSurcharges,
                    visible: !_.isEmpty(discountsAndSurcharges)
                },
                [`additionalInterestsTableGrid${index}`] : {
                    data: location.additionalInterests,
                    visible: location.additionalInterests.length > 0
                },
                [`additionalInterestsContainer${index}`] : {
                    visible: location.additionalInterests.length > 0
                },
                ...generateScheduleDataOverrides(location.filteredSchedules),
                ...generateFarmOutBuildingDataOverride(location.farmOutbuildings),
            };
        });
        return Object.assign({}, ...overrides);
    }, [farmLOBData, generateScheduleDataOverrides,farmCoverageOpenItems]);


    const overrides = {
        farmPolicyCoverageId: {
            value : farmLOBData.farmerPolicyCoverages
        },
        ...generateAccordionHeaderOverrides()
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveValue: readValue,
        resolveCallbackMap: {
            getCell: getCell,
        },
        resolveComponentMap: {
            coveragescomponent: CoveragesComponent,
            scheduleitemscomponent: ScheduleItemsDisplayComponent,
            farmPolicyCoverageComponent: PolicyCoverageComponent,
            discountscomponent: DiscountComponent
        }
    };
    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={farmLOBData}
            overrideProps={overrides}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}
PolicyFarmInfoComponent.propTypes = {
    value: PropTypes.shape({}).isRequired
};
export default PolicyFarmInfoComponent;
